import { Injectable } from '@angular/core';
import { EntityStore } from '@examdojo/state';
import { AssignmentBuilderSectionStoreModel, AssignmentBuilderState } from './assignment-builder.model';

@Injectable({ providedIn: 'root' })
export class AssignmentBuilderStore extends EntityStore<
  AssignmentBuilderState,
  AssignmentBuilderSectionStoreModel,
  'id'
> {
  constructor() {
    super({
      name: 'assignment-builder',
      idKey: 'id',
      initialPropsState: { isDirty: false },
    });
  }
}
